import { createRouter, createWebHistory } from 'vue-router'
  import HomeView from '../views/HomeView.vue'
  import CardView from '../views/CardView.vue'
  import QRCard from '../views/QRCard.vue'
  const CardEditorView = () => import('../views/CardEditorView.vue')
  const LoginView = () => import('../views/LoginView.vue')
  const DashboardView = () => import('../views/Dashboard/Layout.vue')
  const DashboardHome = () => import('../views/Dashboard/DashboardHome.vue')
  const DashboardCardsView = () => import('../views/Dashboard/DashboardCards.vue')
  const DashboardCardDetail = () => import('../views/Dashboard/DashboardCardDetail.vue')
  const DashboardProfile = () => import('../views/Dashboard/DashboardProfile.vue')
  const DashboardSubscription = () => import('../views/Dashboard/DashboardSubscription.vue')
  const DashboardSupport = () => import('../views/Dashboard/DashboardSupport.vue')
  const DashboardSettings = () => import('../views/Dashboard/DashboardSettings.vue')
  const ActivateView = () => import('../views/ActivateView.vue')
  const TestUpload = () => import('../views/TestUpload.vue')

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/card/:id',
    name: 'Card',
    component: CardView,
    alias: '/:id'
  },
  {
    path: '/card/:id/edit',
    name: 'CardEdit',
    component: CardEditorView,
    meta: { requiresAuth: true }
  },
  {
    path: '/qr/:id',
    name: 'QRCard',
    component: QRCard
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/dashboard',
    component: DashboardView,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'DashboardHome',
        component: DashboardHome,
        meta: { requiresAuth: true }
      },
      {
        path: 'cards',
        name: 'DashboardCards',
        component: DashboardCardsView,
        meta: { requiresAuth: true }
      },
      {
        path: 'cards/:id',
        name: 'DashboardCardDetail',
        component: DashboardCardDetail,
        meta: { requiresAuth: true, hideDashboardHeader: true }
      },
      {
        path: 'profile',
        name: 'DashboardProfile',
        component: DashboardProfile,
        meta: { requiresAuth: true }
      },
      {
        path: 'subscription',
        name: 'DashboardSubscription',
        component: DashboardSubscription,
        meta: { requiresAuth: true }
      },
      {
        path: 'support',
        name: 'DashboardSupport',
        component: DashboardSupport,
        meta: { requiresAuth: true, hideDashboardHeader: true }
      },
      {
        path: 'settings',
        name: 'DashboardSettings',
        component: DashboardSettings,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/activate/:id',
    name: 'Activate',
    component: ActivateView,
    meta: { requiresAuth: true }
  }
  ,{
    path: '/activate',
    name: 'ActivateNoId',
    component: ActivateView,
    meta: { requiresAuth: true }
  },
  {
    path: '/test-upload',
    name: 'TestUpload',
    component: TestUpload,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Global auth guard
router.beforeEach((to, from, next) => {
  if (to.meta?.requiresAuth) {
    const token = localStorage.getItem('token')
    if (!token) {
      return next({ name: 'Login', query: { next: to.fullPath } })
    }
  }
  return next()
})

export default router
